import axios from 'axios';
import {
    createOrderRequest,
    createOrderSuccess,
    createOrderFail,
    getOrdersRequest,
    getOrdersSuccess,
    getOrdersFail
} from '../slices/orderSlice';

export const createNewOrder = (orderData) => async (dispatch) => {
    try {
        dispatch(createOrderRequest())

        const { data } = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/v1/order/create`,
            orderData,
            { headers: { "Content-Type": "application/json" } }
        );
        dispatch(createOrderSuccess(data))
    } catch (error) {
        //handle error
        const message =
            error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(createOrderFail(message))
    }

}

export const getOrders = () => async (dispatch) => {
    try {
        dispatch(getOrdersRequest())
        const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/admin/orders/get`);
        dispatch(getOrdersSuccess(data))
    } catch (error) {
        //handle error
        const message =
            error?.response?.data?.message || error.message || "Something went wrong";
        dispatch(getOrdersFail(message))
    }

}
